import { getApiClient } from "@punchup/utils";
import type { UpdateComedianScheduledJobPayload } from "../../models/messaging/scheduled-job-edit.types";

export async function updateComedianScheduledJob(
  jobId: string,
  payload: UpdateComedianScheduledJobPayload
): Promise<{ updated: boolean }> {
  return getApiClient()
    .patch<{ data: { updated: boolean } }>(
      `/api/v2/manager/messaging/jobs/update/${jobId}`,
      payload
    )
    .then((res) => res.data);
}
